/* @flow */
// typecheck: ignore file
import type { Action } from 'action';
import { Map } from 'immutable';
import type { OrganizationClassesFetchOptions } from 'sagas/organizationClasses';

export type OrganizationClassesTable = {
  page: number,
  groups: Group[],
  loading: boolean,
  allLoaded: boolean,
};

export type State = Map<number, OrganizationClassesTable>;
export const initialState: State = new Map();

export default function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'organizationClassTables/INITIALIZE_TABLE': {
      return state.set(action.organizationId, {
        page: 1,
        groups: [],
        loading: false,
        allLoaded: false,
      });
    }

    case 'organizationClassTables/LOAD_ORGANIZATION_CLASSES_SUCCESS': {
      const table = state.get(action.organizationId);

      return state.set(action.organizationId, {
        loading: false,
        page: action.options.page,
        allLoaded: action.groups.length < action.options.perPage,
        groups: action.options.page === 1 ? action.groups : [].concat(table.groups, action.groups),
      });
    }

    default: {
      return state;
    }
  }
}

export type LoadOrganizationClassesRequest = {
  type: 'organizationClassTables/LOAD_ORGANIZATION_CLASSES_REQUEST',
  options: OrganizationClassesFetchOptions,
  organizationId: number,
}

export function loadOrganizationClasses(organizationId: number, options: OrganizationClassesFetchOptions): LoadOrganizationClassesRequest {
  return {
    type: 'organizationClassTables/LOAD_ORGANIZATION_CLASSES_REQUEST',
    organizationId,
    options,
  };
}

export type LoadOrganizationClassesSuccess = {
  type: 'organizationClassTables/LOAD_ORGANIZATION_CLASSES_SUCCESS',
  options: OrganizationClassesFetchOptions,
  organizationId: number,
  groups: Group[],
};

export function loadOrganizationClassesSuccess(organizationId: number, groups: Group[], options: OrganizationClassesFetchOptions): LoadOrganizationClassesSuccess {
  return {
    type: 'organizationClassTables/LOAD_ORGANIZATION_CLASSES_SUCCESS',
    organizationId,
    options,
    groups,
  };
}

export type InitializeTableAction = {
  type: 'organizationClassTables/INITIALIZE_TABLE',
  organizationId: number,
};

export function initializeTable(organizationId: number): InitializeTableAction {
  return {
    type: 'organizationClassTables/INITIALIZE_TABLE',
    organizationId,
  };
}

export type OrganizationClassesTablesAction =
  InitializeTableAction |
  LoadOrganizationClassesRequest |
  LoadOrganizationClassesSuccess;



// WEBPACK FOOTER //
// ./src/reducers/organizationClassesTables.js